import * as React from "react";
import "./ctaButton.css";
import "../../style/fonts.css";
import { nonWhiteSpace } from "html2canvas/dist/types/css/syntax/parser";

export interface Props {
  text: string;
  width: string;
  color: string;
  disabled?: boolean;
  onClick?: () => void;
}

class CtaButton extends React.Component<Props, any> {
  constructor(props) {
    super(props);
  }
  render() {
    const ctaStyle = {
      width: this.props.width,
    };
    let className = "CTA";
    if (this.props.color == "blue") {
      className = "CTA_BLUE";
    }
    if (this.props.disabled) {
      className = "CTA_DISABLED";
    }

    return (
      <button
        className={className}
        style={ctaStyle}
        disabled={this.props.disabled}
        onClick={this.props.onClick}
      >
        {this.props.text}
      </button>
    );
  }
}

export default CtaButton;



// WEBPACK FOOTER //
// ./src/components/ctaButton/ctaButton.tsx